export const disabledColumnOptions = new Map<string, string>([
    ['true', 'Disabled'],
    ['false', 'Enabled']
])

export const galvanicTreatmentOptions = new Map<string, string>([
    ['true', 'Yes'],
    ['false', 'No']
])

export const semifinishedSupplierOptions = new Map<string, string>([
    ['true', 'Yes'],
    ['false', 'No']
])

export const maxRank = 2147483647
export const NONE_VALUE = 0
